import { useEffect, useState, useRef } from "react";

/**
 * Mobile-only tap splash effect.
 * Renders a brief radial light burst wherever the user touches the screen.
 * Listens to `touchstart` only — desktop click is intentionally unaffected.
 */
export default function TouchSplash() {
  const [splashes, setSplashes] = useState([]);
  const idRef = useRef(0);

  useEffect(() => {
    const onTouchStart = (e) => {
      if (!e.touches || !e.touches.length) return;
      const t = e.touches[0];
      const target = e.target;
      // Skip splash if user tapped an interactive control we want responsive feel on
      // (still fire for general body taps; only skip for specific known elements).
      if (target && target.closest && target.closest("input, textarea")) return;

      const id = ++idRef.current;
      const next = { id, x: t.clientX, y: t.clientY };
      setSplashes((prev) => [...prev, next]);
      // Auto-cleanup after the animation length
      window.setTimeout(() => {
        setSplashes((prev) => prev.filter((s) => s.id !== id));
      }, 700);
    };

    window.addEventListener("touchstart", onTouchStart, { passive: true });
    return () => window.removeEventListener("touchstart", onTouchStart);
  }, []);

  return (
    <div aria-hidden="true" className="touch-splash-layer">
      {splashes.map((s) => (
        <span
          key={s.id}
          className="touch-splash"
          style={{ left: s.x, top: s.y }}
          data-testid="touch-splash"
        />
      ))}
    </div>
  );
}
